module.exports = __webpack_public_path__ + "img/300-26c448.png";